class ArchiveNursery {
	constructor() {

		this.body = document.querySelector("body");
		this.listingMapContainer = document.querySelector(".container-map");
		this.listingMap = document.querySelector(".listing-nursery-map");
		this.mapToggleTrigger = document.querySelector(".listing-nursery-map-toggle");

		if (this.listingMap) {
			this.mapPinning();
			this.mapToggle();
			resizeCallbacks.push(this);
		}

	}

	mapPinning() {
		ScrollTrigger.matchMedia({
			'(max-width: 990px)': () => {
				gsap.set(this.listingMap, {
					clearProps: "all"
				});
				ScrollTrigger.create({
					trigger: this.listingMapContainer,
					start: "top top",
					endTrigger: ".listing-nursery",
					end: 'bottom bottom',
					pin: true,
					pinSpacing: false,
				});

				ScrollTrigger.create({
					trigger: this.body,
					start: "top top",
					endTrigger: ".listing-nursery",
					end: 'bottom bottom',
					onToggle: (self) => {
						if (self.isActive) {
							this.mapToggleTrigger.classList.add("toggle-active");
						} else {
							this.mapToggleTrigger.classList.remove("toggle-active");
						}
					}
				});
			},
			'(min-width: 991px)': () => {
				ScrollTrigger.create({
					trigger: this.listingMap,
					start: "top top",
					endTrigger: ".listing-nursery",
					end: 'bottom bottom',
					pin: true,
					pinSpacing: false,
				});
			}

		});
	}

	mapToggle() {
		this.mapToggleTrigger.addEventListener('click', () => {
			this.body.classList.toggle("map-active");
		});
	}


	resize() {
		if (this.listingMap && window.innerWidth < 768) {
			this.listingMap.style.removeProperty('transform');
		} else {
			this.body.classList.remove("map-active");
			this.mapToggle.classList.remove("toggle-active");
		}
	}
}